var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShowCover = function SvgShowCover(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "show-cover_svg__mask0_5102_5338",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    width: 20,
    height: 20,
    transform: "rotate(90 20 0)",
    fill: "#FF0606"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#show-cover_svg__mask0_5102_5338)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.95915 4.16663C3.38363 4.16663 2.91717 4.63334 2.91748 5.20885L2.92053 10.9206L4.55707 9.37205C5.43601 8.54037 6.8101 8.53538 7.69507 9.36064L9.82076 11.3429L11.2003 10.1733C12.0546 9.44905 13.3073 9.44842 14.1624 10.1718L17.0833 12.643L17.0832 5.20829C17.0832 4.63299 16.6169 4.16663 16.0416 4.16663L3.95915 4.16663ZM2.9226 14.7922L2.92144 12.6246L2.92945 12.633L5.4162 10.28C5.81572 9.90197 6.44031 9.8997 6.84257 10.2748L9.37473 12.6361C9.60652 12.8523 9.9634 12.8607 10.2051 12.6558L12.0086 11.1268C12.397 10.7976 12.9664 10.7973 13.3551 11.1261L17.0833 14.2803L17.0833 14.7916C17.0833 15.3669 16.6169 15.8333 16.0416 15.8333L3.96427 15.8333C3.38919 15.8333 2.92291 15.3673 2.9226 14.7922ZM1.66748 5.20952C1.6668 3.94339 2.69302 2.91663 3.95915 2.91663L16.0416 2.91663C17.3072 2.91663 18.3332 3.94264 18.3332 5.20829L18.3333 14.7916C18.3333 16.0573 17.3072 17.0833 16.0416 17.0833L3.96427 17.0833C2.6991 17.0833 1.67328 16.058 1.6726 14.7929L1.66748 5.20952ZM13.5417 7.91663C14.117 7.91663 14.5833 7.45026 14.5833 6.87496C14.5833 6.29966 14.117 5.83329 13.5417 5.83329C12.9664 5.83329 12.5 6.29966 12.5 6.87496C12.5 7.45026 12.9664 7.91663 13.5417 7.91663Z",
    fill: "#11141A"
  }))));
};
export default SvgShowCover;